import { Document, Page } from "react-pdf"
import Button from "../../Button/Button"
import React, { useEffect, useRef, useState } from "react"
import CustomSpinner from "../../Spiner/CustomSpiner"
import { CrossCloseIcon } from "../../Icons/Icons"
import { useDispatch } from "react-redux"
import { useMyContextLoading } from "../../LoadingContextProvider/LoadingContextProvider"
import { sendEmailReq } from "../../../features/emails/emails"
import { showSnackBar } from "../../Snackbar/Snackbar"
import { isEmptyFields } from "../../../helpers/helper"
import ResizableContentEditable from "./ResizableContentEditable"
import { SENDER_EMAIL } from "../../../config/consts"
import { useStaffBrandContext } from "../../StaffBrand/StaffBrandContext"

const EmailTemplate = ({
  selectedFiles,
  selectedFilesBase64,
  loading,
  setSelectedFiles,
  setSelectedFilesBase64,
  userData,
  setTab,
  textAreaTemplate,
  subjectTemp,
  filesStrict = false,
}) => {
  const dispatch = useDispatch()
  const staffBrand = useStaffBrandContext()
  const adminObjectString = localStorage.getItem("user")
  const adminObject = JSON.parse(adminObjectString)

  const textareaRef = useRef(null)
  const [hoveredFiles, setHoveredFiles] = useState({})
  const [subject, setSubject] = useState('')
  const [textArea, setTextArea] = useState('')
  const { triggerLoading } = useMyContextLoading()
  const handleMouseEnter = (fileKey) => {
    setHoveredFiles(prevState => ({ ...prevState, [fileKey]: true }))
  }

  const handleMouseLeave = (fileKey) => {
    setHoveredFiles(prevState => ({ ...prevState, [fileKey]: false }))
  }

  const handleChange = (event) => {
    const element = event.target
    if (element.style) {
      element.style.height = 'auto'
      element.style.height = `${element.scrollHeight}px`
    }
    setTextArea(element.value)
  }

  const sendEmail = async () => {
    triggerLoading(true)
    const data = {
      subject,
      htmlContent: textAreaTemplate?.length > 0 ? textArea : `<body>
  <div>${textArea}</div>
</body>`,
      attachments: (filesStrict ? selectedFilesBase64.filter((file) => typeof file?.file === 'string') : selectedFilesBase64).map((file) => {
        return {
          url: file?.url || file?.key,
          name: file?.key
        }
      })
    }

    const response = await dispatch(sendEmailReq({ userId: userData?._id, data }))
    if (response?.payload?.status === "success") {
      showSnackBar("success", "The email was successfully sent")
      setTab("allEmail")
    }
    triggerLoading(false)
  }

  useEffect(() => {
    setTextArea('')
    setTextArea(textAreaTemplate);
    setSubject(subjectTemp);
  }, [textAreaTemplate]);

  return (
    <div className="w-full rounded-2xl shadow-lg border border-divider">
      <h5 className="font-bold text-lg-18 px-6 py-3 border-b border-divider">New Message</h5>
      <div className=" px-6 py-3 border-b border-divider flex">
        <p className="w-[80px] text-text-secondary">From</p>
        <input disabled={true} className="w-full bg-transparent text-text-primary disabled:opacity-100 focus:outline-none focus:border-transparent"
          value={staffBrand?.firmIdentity && staffBrand.senderEmail ? staffBrand.senderEmail : SENDER_EMAIL} />
      </div>
      <div className="px-6 py-3 border-b border-divider flex">
        <p className="w-[80px] text-text-secondary">To</p>
        <input disabled={true} className="w-full bg-transparent text-text-primary disabled:opacity-100 focus:outline-none" value={userData?.secondaryEmail} />
      </div>
      <div className="px-6 py-3 border-b border-divider flex">
        <p className="w-[80px] text-text-secondary">Subject</p>
        <input value={subject} className="w-full font-bold bg-transparent text-text-primary placeholder:text-text-secondary focus:outline-none focus:border-transparent"
          onChange={(e) => setSubject(e.target.value)} />
      </div>
      <div className="px-6 pt-3 pb-6 border-b border-divider flex overflow-scroll">
        <ResizableContentEditable
          innerRef={textareaRef}
          html={textArea}
          onChange={handleChange}
          className="w-full h-max min-h-20 max-h-max "
          classNameContentEditable="focus:outline-none focus:border-transparent min-h-20 max-h-max break-words [overflow-wrap:anywhere]"
        />
      </div>
      {selectedFiles?.length > 0 && <div className="px-6 py-3 border-b border-divider flex">
        {selectedFiles.map((file) => {
          const isLoading = loading.some((loadingFile) => loadingFile.key === file.key)

          return (
            <div key={file.key} className="p-2">
              {isLoading ? (
                <div className="w-[56px] h-[56px] rounded-lg">
                  <CustomSpinner />
                </div>
              ) : (
                selectedFilesBase64.map((loadingFile) => loadingFile.key === file.key && (!filesStrict || typeof loadingFile?.file === 'string') ?
                  <div
                    className="w-[56px] h-[56px] rounded-lg overflow-hidden cursor-pointer select-none relative"
                    onMouseEnter={() => handleMouseEnter(file.key)}
                    onMouseLeave={() => handleMouseLeave(file.key)}
                    onClick={() => {
                      setSelectedFiles(prevSelectedFiles => prevSelectedFiles.filter(selectedFile => selectedFile !== file))
                      setSelectedFilesBase64(prevSelectedFiles => prevSelectedFiles.filter(selectedFile => selectedFile.key !== file.key))
                    }}
                  >
                    {loadingFile?.file.split(";base64").shift() === "data:image/png" || loadingFile?.file.split(";base64").shift() === "data:image/jpg" || loadingFile?.file.split(";base64").shift() === "data:image/jpeg" ? (
                      <img src={loadingFile?.file} alt="Image" />
                    ) : <Document file={loadingFile?.file}>
                      <Page className="flex  " pageNumber={1} width={56} height={56} />
                    </Document>}
                    {hoveredFiles[file.key] && (
                      <div
                        className="absolute inset-0 z-[1] flex items-center justify-center rounded-md bg-black/30"
                      >
                        <CrossCloseIcon />
                      </div>
                    )}
                  </div>
                  : "")
              )}
            </div>
          )
        })
        }
      </div>}

      <div className="px-6 py-3 flex">
        <Button width="w-[68px]" size="sm" disabled={isEmptyFields(subject) || isEmptyFields(textArea)}
          onClick={async () => await sendEmail()}>Send</Button>
      </div>
    </div>
  )
}

export default EmailTemplate